module.exports = __webpack_public_path__ + "img/score-null.c7b67b82.svg";